<template>
  <div class="database-container">
    <!--  添加一个轮播公告  -->
    <div class="announcement-container" v-if="notices && notices.length > 0">
      <div class="announcement-content">
        <div class="announcement-item" :key="currentNoticeIndex">
          {{ notices[currentNoticeIndex].message }}
        </div>
      </div>
    </div>
    
    <a-tabs v-model="value" @change="changeTabs" class="custom-tabs">
      <a-tab-pane :tab="translate('database.tab.title1')" key="dtzz">
        <div class="dashboard-content">
          <a-row :gutter="[24, 24]">
            <!-- 左侧主要内容 -->
            <a-col :xs="24" :lg="14">
              <!-- 流量统计卡片 -->
              <a-card class="flow-card content-card">
                <div class="flow-header">
                  <a-icon type="cloud" class="flow-icon" />
                  <div class="flow-title">{{ translate('database.header.contant1') }}</div>
                </div>
                <!-- 新增的直接显示的提示文本 -->
                <div style="font-size: 12px; color: rgba(255, 255, 255, 0.6); margin-bottom: 12px; line-height: 1.5;">
                  <a-icon type="info-circle" style="margin-right: 4px;" />
                  {{ translate('database.header.trafficDelayTip') }}
                </div>
                <div class="flow-stats">
                  <div class="flow-item">
                    <span class="flow-label">{{ translate('database.header.contant1') }}</span>
                    <span class="flow-value">{{ this.flowoverdue}}GB</span>
                  </div>
                  <a-divider style="margin: 12px 0; border-color: rgba(255, 255, 255, 0.2);" />
                  <div class="flow-item">
                    <span class="flow-label">{{ translate('database.header.contant2') }}</span>
                    <span class="flow-value">{{ this.flow }}GB</span>
                  </div>
                </div>
                <a-progress 
                  :percent="parseFloat(flowoverdue && flow ? (flowoverdue / flow * 100).toFixed(1) : 0)" 
                  :stroke-width="8" 
                  :stroke-color="{ '0%': '#fff', '100%': '#fff' }"
                  :trail-color="'rgba(255, 255, 255, 0.3)'"
                  :format="() => ''"
                />
              </a-card>
              
              <!-- 代理信息卡片 -->
              <a-card class="content-card proxy-card compact-card">
                <div class="card-header compact-header">
                  <a-icon type="info-circle" class="header-icon" />
                  <div class="header-title">{{ translate('database.tab.title1') }}</div>
                </div>
                
                <div class="proxy-info-container compact-proxy">
                  <div class="proxy-info-group">
                    <div class="proxy-info-item">
                      <div class="proxy-info-label">{{ translate('database.banner.contant1') }}</div>
                      <div class="proxy-info-content">
                        <div style="display: flex; align-items: center;">
                          <span>{{ formData.host }}</span>
                          <a-icon type="copy" style="cursor: pointer; margin-left: 8px;" @click="copy" id="equSN" :data-clipboard-text="formData.host" />
                        </div>
                      </div>
                    </div>
                    <div class="proxy-info-tip compact-tip">
                      <a-alert
                        :message="translate('database.banner.contant5')"
                        type="info"
                      />
                    </div>
                  </div>
                  
                  <div class="proxy-info-group">
                    <div class="proxy-info-item">
                      <div class="proxy-info-label">{{ translate('database.banner.contant2') }}</div>
                      <div class="proxy-info-content">
                        <div style="display: flex; align-items: center;">
                          <span>{{ formData.port }}</span>
                          <a-icon type="copy" style="cursor: pointer; margin-left: 8px;" @click="copy" id="equSN" :data-clipboard-text="formData.port" />
                        </div>
                      </div>
                    </div>
                    <div class="proxy-info-tip compact-tip">
                      <a-alert
                        :message="translate('database.banner.contant6')"
                        type="info"
                      />
                    </div>
                  </div>
                  
                  <div class="proxy-info-group">
                    <div class="proxy-info-item">
                      <div class="proxy-info-label">{{ translate('database.banner.contant3') }}</div>
                      <div class="proxy-info-content">
                        <div style="display: flex; align-items: center;">
                          <span>{{ formData.username }}</span>
                          <a-icon type="copy" style="cursor: pointer; margin-left: 8px;" @click="copy" id="equSN" :data-clipboard-text="formData.username" />
                        </div>
                      </div>
                    </div>
                    <div class="proxy-info-tip compact-tip">
                      <a-alert
                        :message="translate('database.banner.contant7')"
                        type="info"
                      />
                    </div>
                  </div>
                  
                  <div class="proxy-info-group">
                    <div class="proxy-info-item">
                      <div class="proxy-info-label">{{ translate('database.banner.contant4') }}</div>
                      <div class="proxy-info-content">
                        <div style="display: flex; align-items: center;">
                          <span>{{ formData.password }}</span>
                          <a-button type="primary" @click="changeAuthPassword" style="margin: 0 8px; padding: 0 12px; height: 28px; font-size: 12px;">{{ translate('resetPassword') }}</a-button>
                          <a-icon type="copy" style="cursor: pointer; margin-left: 8px;" @click="copy" id="equSN" :data-clipboard-text="formData.password" />
                        </div>
                      </div>
                    </div>
                    <div class="proxy-info-tip compact-tip">
                      <a-alert
                        :message="translate('database.banner.contant8')"
                        type="info"
                      />
                    </div>
                  </div>
                </div>
              </a-card>
            </a-col>
            
            <!-- 右侧内容 -->
            <a-col :xs="24" :lg="10">
              <!-- 代理生成卡片 -->
              <a-card class="content-card proxy-result-card highlight-card">
                <div class="card-header">
                  <a-icon type="code" class="header-icon" />
                  <div class="header-title">{{ translate('database.banner.contant17') }}</div>
                </div>
                
                <div class="select-row" style="margin-bottom: 20px;">
                  <!-- 国家选择 -->
                  <div class="select-item">
                    <div class="config-item">
                      <span class="config-label">{{ translate('database.header.contant3') }}</span>
                      <a-select :placeholder="translate('database.header.contant3')" v-model="country" @change="changeCode" show-search optionFilterProp="children">
                        <template v-if="currentLanguage === 'en'">
                          <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.iso">{{ item.countriesEn }}</a-select-option>
                        </template>
                        <template v-else-if="currentLanguage === 'zh'">
                          <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.iso">{{ item.countriesCn }}</a-select-option>
                        </template>
                      </a-select>
                    </div>
                  </div>
                  <!-- 地区选择 -->
                  <div class="select-item">
                    <div class="config-item">
                      <span class="config-label">{{ translate('database.header.contant4') }}</span>
                      <a-select :placeholder="translate('database.header.contant4')" v-model="state" @change="changeState">
                        <a-select-option v-for="item in AreaList" :value="item.region" :key="item.region">{{ currentLanguage === 'zh' ? item.region : item.region }}</a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <!-- 城市选择 -->
                  <div class="select-item">
                    <div class="config-item">
                      <span class="config-label">{{ translate('database.header.contant5') }}</span>
                      <a-select :placeholder="translate('database.header.contant5')" v-model="citycode" @change="changeCity">
                        <a-select-option v-for="item in CityList" :value="item.city" :key="item.city">{{ currentLanguage === 'zh' ? item.city : item.city }}</a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <!-- 子账户选择 -->
                  <div class="select-item">
                    <div class="config-item">
                      <span class="config-label">{{ translate('database.header.contant6') }}</span>
                      <a-select :placeholder="translate('database.header.contant6')" v-model="sonAccount" @change="changeSon">
                        <a-select-option v-for="item in sonlist" :value="item.username" :key="item.username">{{ item.username }}</a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <!-- 协议选择 -->
                   <div class="select-item">
                    <div class="config-item">
                      <span class="config-label">{{ translate('database.header.contant7') }}</span>
                      <a-select :placeholder="translate('database.header.contant7')">
                        <a-select-option value="socks5" key="socks5">socks5</a-select-option>
                        <a-select-option value="http" key="http" disabled>http</a-select-option>
                      </a-select>
                    </div>
                  </div>
                </div>
                
                <div class="select-row" style="margin-bottom: 20px;">
                  <div class="select-item">
                    <div class="config-item">
                      <span class="config-label">{{ translate('database.banner.contant9') }}</span>
                      <a-select :placeholder="translate('database.banner.contant9')" default-value="10" @change="changeLength">
                        <a-select-option v-for="item in proxyListLength" :value="item.value" :key="item.value">{{ item.value }}</a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <div class="select-item">
                    <div class="config-item">
                      <span class="config-label">{{ translate('database.banner.contant10') }}</span>
                      <a-select :placeholder="translate('database.banner.contant10')" default-value="5" @change="changeTime">
                        <a-select-option v-for="item in proxyTimeList" :value="item.value" :key="item.value">{{ item.value }}</a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <div class="select-item">
                    <div class="config-item">
                      <span class="config-label">{{ translate('database.banner.contant11') }}</span>
                      <a-select :placeholder="translate('database.banner.contant12')" @change="changeProxy">
                        <a-select-option v-for="item in FormatList" :value="item.dictValue" :key="item.dictCode">{{ item.dictValue }}</a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <div class="select-item">
                    <div class="config-item">
                      <span class="config-label">{{ translate('database.banner.contant13') }}</span>
                      <a-select :placeholder="translate('database.banner.contant12')" @change="changeTimes">
                        <a-select-option :label="translate('database.banner.contant14')" value="0" :key="0">{{ translate('database.banner.contant14') }}</a-select-option>
                        <a-select-option :label="translate('database.banner.contant15')" value="1" :key="1">{{ translate('database.banner.contant15') }}</a-select-option>
                      </a-select>
                    </div>
                  </div>
                </div>
                
                <div class="action-bar">
                  <a-button type="primary" @click="getProxyList" class="generate-btn">
                    {{ translate('database.banner.contant17') }}
                  </a-button>
                  <div style="flex: 1;"></div>
                  <a-space class="action-buttons">
                    <a-button @click="downloadTxt" icon="download" class="action-btn">
                      {{ translate('database.banner.contant16') || '下载' }}
                    </a-button>
                    <a-button @click="copy" id="equSN" :data-clipboard-text="this.ProxyContant" icon="copy" class="action-btn copy-btn">
                      {{ translate('database.banner.contant18') || '复制' }}
                    </a-button>
                  </a-space>
                </div>
                
                <a-textarea 
                  v-model="this.ProxyContant" 
                  read-only 
                  :auto-size="{ minRows: 8, maxRows: 15 }" 
                  class="proxy-textarea"
                />
              </a-card>
            </a-col>
          </a-row>
        </div>
      </a-tab-pane>
      
      <a-tab-pane :tab="translate('database.tab.title2')" key="jtzz">
        <a-card class="content-card">
          <div class="card-header">
            <a-icon type="table" class="header-icon" />
            <div class="header-title">{{ translate('database.tab.title2') }}</div>
          </div>
          
          <div class="select-row" style="margin-bottom: 20px;">
            <div class="select-item-large">
              <a-select :placeholder="translate('database.tab2.contant1')" @change="changeCodejt" show-search optionFilterProp="children">
                <template v-if="currentLanguage === 'en'">
                  <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.Andorra">{{ item.countriesEn }}</a-select-option>
                </template>
                <template v-else-if="currentLanguage === 'zh'">
                  <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.Andorra">{{ item.countriesCn }}</a-select-option>
                </template>
              </a-select>
            </div>
            <div class="select-item-small">
              <a-select placeholder="socks5" default-value="socks5">
                <a-select-option value="socks5" :key="0">socks5</a-select-option>
                <a-select-option value="http" :key="1" disabled>http</a-select-option>
              </a-select>
            </div>
          </div>
          
          <a-table
              :columns="columns"
              :data-source="dataList"
              :loading="dataLoading"
              :rowKey="rowKey"
              :pagination="pagination"
              :scroll="{ x: 1200 }"
              class="custom-table modern-table"
            >
            </a-table>
        </a-card>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { saveAs } from 'file-saver';

export default {
  name: 'DynamicResidence',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'en';
    },
    t() {
      const lang = this.currentLanguage;
      return {
        tabTitle1: lang === 'zh' ? '动态住宅' : 'Dynamic Residential',
        tabTitle2: lang === 'zh' ? '静态住宅' : 'Static dwellings',
        headerContant1: lang === 'zh' ? '剩余动态 residences:' : 'Remaining Dynamic Residences:',
        headerContant2: lang === 'zh' ? '总带宽:' : 'Total bandwidth:',
        headerContant3: lang === 'zh' ? '请选择国家' : 'Please select a country',
        headerContant4: lang === 'zh' ? '请选择地区' : 'Please select a region',
        headerContant5: lang === 'zh' ? '请选择城市' : 'Please select a city',
        headerContant6: lang === 'zh' ? '选择子账户' : 'Select the sub-account',
        headerContant7: lang === 'zh' ? '选择协议' : 'Select the protocol',
        bannerContant1: lang === 'zh' ? '主机' : 'host',
        bannerContant2: lang === 'zh' ? '端口' : 'port',
        bannerContant3: lang === 'zh' ? '用户名' : 'Username',
        bannerContant4: lang === 'zh' ? '密码' : 'password',
        bannerContant5: lang === 'zh' ? '将其放入您的IP/托管设置' : 'Put it into your IP/hosting settings',
        bannerContant6: lang === 'zh' ? '使用指定的端口。每个端口是一个独立的粘性会话，最大长度为120分钟' : 'Use the specified port. Each port is a separate sticky session with a maximum length of 120 minutes',
        bannerContant7: lang === 'zh' ? '您的用户名，对于住宅代理，您会注意到在使用上面的定位选项时用户名会动态变化' : 'Your username, for residential proxies, you will notice that the username changes dynamically when you use the targeting options above',
        bannerContant8: lang === 'zh' ? '您的密码' : 'Your password',
        bannerContant9: lang === 'zh' ? '代理列表长度:' : 'The length of the proxy list:',
        bannerContant10: lang === 'zh' ? '代理时间(分钟):' : 'Agency Time (min):',
        bannerContant11: lang === 'zh' ? '代理链接格式:' : 'Proxy link format:',
        bannerContant12: lang === 'zh' ? '请选择' : 'Please select',
        bannerContant13: lang === 'zh' ? '时间模式:' : 'Timeframe mode:',
        bannerContant14: lang === 'zh' ? '定期更换' : 'Replace it regularly',
        bannerContant15: lang === 'zh' ? '一次换一个' : 'One change at a time',
        bannerContant17: lang === 'zh' ? '生成' : 'Generate',
        tab2Contant1: lang === 'zh' ? '请选择国家' : 'Please select a country',
        tab2Contant2: lang === 'zh' ? '主机' : 'host',
        tab2Contant3: lang === 'zh' ? '端口' : 'port',
        tab2Contant4: lang === 'zh' ? '用户名' : 'Username',
        tab2Contant5: lang === 'zh' ? '密码' : 'password',
        tab2Contant6: lang === 'zh' ? 'IP属性' : 'IP attribution',
        tab2Contant7: lang === 'zh' ? '生效时间' : 'Effective time',
        tab2Contant8: lang === 'zh' ? '到期时间' : 'Expiration time',
        resetPassword: lang === 'zh' ? '重置密码' : 'Reset password',
      };
    },
    columns() {
      return [
        {
          title: this.t.tab2Contant2,
          fixed: 'left',
          width: 200,
          align: 'left',
          ellipsis: true,
          dataIndex: 'uid',
          key: 'uid',
        },
        {
          title: this.t.tab2Contant3,
          width: 200,
          ellipsis: true,
          dataIndex: 'creatTime',
          key: 'creatTime',
        },
        {
          title: this.t.tab2Contant4,
          width: 200,
          ellipsis: true,
          dataIndex: 'flow',
          key: 'flow',
        },
        {
          title: this.t.tab2Contant5,
          width: 200,
          ellipsis: true,
          dataIndex: 'flowOverdue1',
          key: 'flowOverdue1',
        },
        {
          title: this.t.tab2Contant6,
          width: 200,
          ellipsis: true,
          dataIndex: 'ipArea',
          key: 'ipArea',
        },
        {
          title: this.t.tab2Contant7,
          width: 200,
          ellipsis: true,
          dataIndex: 'flowOverdue2',
          key: 'flowOverdue2',
        },
        {
          title: this.t.tab2Contant8,
          width: 200,
          ellipsis: true,
          dataIndex: 'flowOverdue3',
          key: 'flowOverdue3',
        },
      ];
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      uid: localStorage.getItem("userId"),
      value: 'dtzz',
      StateName:'',
      CityName:'',
      formData:{
        host:'',
        port:'',
        username:'',
        password:'',
      },
      formatid:'',
      life:5,
      listnum:10,
      proxyType:'socks5',
      citycode:undefined,
      state:undefined,
      dyType:'',
      country:'US',
      selectedMode:0,
      
      rowKey: 'index',
      dataLoading: false,
      tableLayout: 'auto',
      verticalAlign: 'top',
      bordered: true,
      hover: true,
      pagination: {
        defaultPageSize: 10,
        total: 0,
        defaultCurrent: 1,
      },
      //静态列表
      dataList:[
        // { "uid":0,"creatTime":11,"flow":"小姜","flowOverdue1":5,"flowOverdue4":1,"flowOverdue3":1 }
      ],
      IsoCodeList:[],
      FormatList:[],
      AreaList:[],
      CityList:[],
      sonlist:[],
      sonAccount:undefined,
      ProxyContant:'',
      flow:'', //总流量
      flowoverdue:'', //剩余流量，获取参数总流量减去该参数
      proxyListLength :[
        {
          value: 10
        },
        {
          value: 20
        },
        {
          value: 30
        },
        {
          value: 40
        },
        {
          value: 50
        },
        {
          value: 100
        },
        {
          value: 500
        },
        {
          value: 1000
        }
      ],
      proxyTimeList:[
        {
          "value": 1
        },
        {
          "value": 2
        },
        {
          "value": 3
        },
        {
          "value": 4
        },
        {
          "value": 5
        },
        {
          "value": 6
        },
        {
          "value": 7
        },
        {
          "value": 8
        },
        {
          "value": 9
        },
        {
          "value": 10
        },
        {
          "value": 11
        },
        {
          "value": 12
        },
        {
          "value": 13
        },
        {
          "value": 14
        },
        {
          "value": 15
        },
        {
          "value": 16
        },
        {
          "value": 17
        },
        {
          "value": 18
        },
        {
          "value": 19
        },
        {
          "value": 20
        },
        {
          "value": 21
        },
        {
          "value": 22
        },
        {
          "value": 23
        },
        {
          "value": 24
        },
        {
          "value": 25
        },
        {
          "value": 26
        },
        {
          "value": 27
        },
        {
          "value": 28
        },
        {
          "value": 29
        },
        {
          "value": 30
        },
        {
          "value": 31
        },
        {
          "value": 32
        },
        {
          "value": 33
        },
        {
          "value": 34
        },
        {
          "value": 35
        },
        {
          "value": 36
        },
        {
          "value": 37
        },
        {
          "value": 38
        },
        {
          "value": 39
        },
        {
          "value": 40
        },
        {
          "value": 41
        },
        {
          "value": 42
        },
        {
          "value": 43
        },
        {
          "value": 44
        },
        {
          "value": 45
        },
        {
          "value": 46
        },
        {
          "value": 47
        },
        {
          "value": 48
        },
        {
          "value": 49
        },
        {
          "value": 50
        },
        {
          "value": 51
        },
        {
          "value": 52
        },
        {
          "value": 53
        },
        {
          "value": 54
        },
        {
          "value": 55
        },
        {
          "value": 56
        },
        {
          "value": 57
        },
        {
          "value": 58
        },
        {
          "value": 59
        },
        {
          "value": 60
        },
        {
          "value": 61
        },
        {
          "value": 62
        },
        {
          "value": 63
        },
        {
          "value": 64
        },
        {
          "value": 65
        },
        {
          "value": 66
        },
        {
          "value": 67
        },
        {
          "value": 68
        },
        {
          "value": 69
        },
        {
          "value": 70
        },
        {
          "value": 71
        },
        {
          "value": 72
        },
        {
          "value": 73
        },
        {
          "value": 74
        },
        {
          "value": 75
        },
        {
          "value": 76
        },
        {
          "value": 77
        },
        {
          "value": 78
        },
        {
          "value": 79
        },
        {
          "value": 80
        },
        {
          "value": 81
        },
        {
          "value": 82
        },
        {
          "value": 83
        },
        {
          "value": 84
        },
        {
          "value": 85
        },
        {
          "value": 86
        },
        {
          "value": 87
        },
        {
          "value": 88
        },
        {
          "value": 89
        },
        {
          "value": 90
        },
        {
          "value": 91
        },
        {
          "value": 92
        },
        {
          "value": 93
        },
        {
          "value": 94
        },
        {
          "value": 95
        },
        {
          "value": 96
        },
        {
          "value": 97
        },
        {
          "value": 98
        },
        {
          "value": 99
        },
        {
          "value": 100
        },
        {
          "value": 101
        },
        {
          "value": 102
        },
        {
          "value": 103
        },
        {
          "value": 104
        },
        {
          "value": 105
        },
        {
          "value": 106
        },
        {
          "value": 107
        },
        {
          "value": 108
        },
        {
          "value": 109
        },
        {
          "value": 110
        },
        {
          "value": 111
        },
        {
          "value": 112
        },
        {
          "value": 113
        },
        {
          "value": 114
        },
        {
          "value": 115
        },
        {
          "value": 116
        },
        {
          "value": 117
        },
        {
          "value": 118
        },
        {
          "value": 119
        },
        {
          "value": 120
        }
      ],
      timer:null,//定时器名称
      noticeTimer:null,//公告轮播定时器
      notices: [],
      currentNoticeIndex: 0,//当前显示的公告索引
    };
  },
  mounted(){
    this.getIsoCodeList();
    this.getProxyflow();
    this.getFormatList();
    this.getProxyList();
    this.getSonAccountList();
    this.start();
    this.getNoticeList();
  },
  updated(){
    // 当公告列表更新时，如果没有定时器且有多个公告，启动轮播
    if(this.notices.length > 1 && !this.noticeTimer){
      this.startNoticeTimer();
    }
  },
  methods:{
    translate(key) {
      const lang = this.currentLanguage;
      const translations = {
        'database.tab.title1': lang === 'zh' ? '动态住宅' : 'Dynamic Residential',
        'database.tab.title2': lang === 'zh' ? '静态住宅' : 'Static dwellings',
        'database.header.contant1': lang === 'zh' ? '剩余动态住宅:' : 'Remaining Dynamic Residences:',
        'database.header.contant2': lang === 'zh' ? '总带宽:' : 'Total bandwidth:',
        'database.header.trafficDelayTip': lang === 'zh' ? '由于国际网络延迟问题，流量统计会出现波动，一般半小时左右更新，如果出现波动会延长到三小时更新。' : 'Due to international network latency, traffic statistics may fluctuate. It is usually updated in about half an hour, and extended to 3 hours if fluctuations occur.',
        'database.header.contant3': lang === 'zh' ? '请选择国家' : 'Please select a country',
        'database.header.contant4': lang === 'zh' ? '请选择地区' : 'Please select a region',
        'database.header.contant5': lang === 'zh' ? '请选择城市' : 'Please select a city',
        'database.header.contant6': lang === 'zh' ? '选择子账户' : 'Select the sub-account',
        'database.header.contant7': lang === 'zh' ? '选择协议' : 'Select the protocol',
        'database.banner.contant1': lang === 'zh' ? '主机' : 'host',
        'database.banner.contant2': lang === 'zh' ? '端口' : 'port',
        'database.banner.contant3': lang === 'zh' ? '用户名' : 'Username',
        'database.banner.contant4': lang === 'zh' ? '密码' : 'password',
        'database.banner.contant5': lang === 'zh' ? '将其放入您的IP/托管设置' : 'Put it into your IP/hosting settings',
        'database.banner.contant6': lang === 'zh' ? '使用指定的端口。每个端口是一个独立的粘性会话，最大长度为120分钟' : 'Use the specified port. Each port is a separate sticky session with a maximum length of 120 minutes',
        'database.banner.contant7': lang === 'zh' ? '您的用户名，对于住宅代理，您会注意到在使用上面的定位选项时用户名会动态变化' : 'Your username, for residential proxies, you will notice that the username changes dynamically when you use the targeting options above',
        'database.banner.contant8': lang === 'zh' ? '您的密码' : 'Your password',
        'database.banner.contant9': lang === 'zh' ? '代理列表长度:' : 'The length of the proxy list:',
        'database.banner.contant10': lang === 'zh' ? '代理时间(分钟):' : 'Agency Time (min):',
        'database.banner.contant11': lang === 'zh' ? '代理链接格式:' : 'Proxy link format:',
        'database.banner.contant12': lang === 'zh' ? '请选择' : 'Please select',
        'database.banner.contant13': lang === 'zh' ? '时间模式:' : 'Timeframe mode:',
        'database.banner.contant14': lang === 'zh' ? '定期更换' : 'Replace it regularly',
        'database.banner.contant15': lang === 'zh' ? '一次一换' : 'One change at a time',
        'database.banner.contant16': lang === 'zh' ? '下载' : 'Download',
        'database.banner.contant17': lang === 'zh' ? '生成' : 'Generate',
        'database.banner.contant18': lang === 'zh' ? '复制' : 'Copy',
        'database.tab2.contant1': lang === 'zh' ? '请选择国家' : 'Please select a country',
        'database.tab2.contant2': lang === 'zh' ? '主机' : 'host',
        'database.tab2.contant3': lang === 'zh' ? '端口' : 'port',
        'database.tab2.contant4': lang === 'zh' ? '用户名' : 'Username',
        'database.tab2.contant5': lang === 'zh' ? '密码' : 'password',
        'database.tab2.contant6': lang === 'zh' ? 'IP属性' : 'IP attribution',
        'database.tab2.contant7': lang === 'zh' ? '生效时间' : 'Effective time',
        'database.tab2.contant8': lang === 'zh' ? '到期时间' : 'Expiration time',
        'resetPassword': lang === 'zh' ? '重置密码' : 'Reset password',
      };
      return translations[key] || key;
    },
    //获取平台公告
    getNoticeList(){
      this.$request.get('/ums/user/getNoticeList',{
        params: {
          dataType: 'proxylink'
        }
      }).then((res) => {
        if (res.data.code === 200) {
          this.notices = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    //登录状态测试
    getLoginStatus(){
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear();
          this.$message.warning('请重新登录！');
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    start(){
      this.timer = setInterval(this.getLoginStatus, 10000); // 第一个参数为方法名的时候不要加括号;
    },
    // 启动公告轮播定时器
    startNoticeTimer(){
      this.noticeTimer = setInterval(() => {
        this.currentNoticeIndex = (this.currentNoticeIndex + 1) % this.notices.length;
      }, 2000); // 每2秒切换一次公告
    },


    //静态代理列表 consum/getProxyStaticList
    getProxyStaticList() {
      this.$request.post('/consum/getProxyStaticList',
        {
          packageType:this.value,
          uid:this.uid,
          city:this.citycode,
          country:this.country,
          formatid:this.formatid,
          life:this.life,
          listnum:this.listnum,
          proxyType:this.proxyType,
          state:this.state,
          selectedMode:this.selectedMode,

        }
      ).then((res) => {
        if (res.data.code === 200) {
          this.dataList = res.data.data;
        }else{
          this.$message.warning(res.data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    //静态国家监听套餐
    changeCodejt(){
      this.getProxyStaticList()
    },

    //监听表格切换
    changeTabs(){
      if(this.value == 'jtzz'){
        this.getProxyStaticList();
      }else{
        console.log('aaa');
      }
    },

    //获取国家码
    getIsoCodeList() {
      this.$request.get('/consum/getIsoCodeList').then((res) => {
        if (res.data.code === 200) {
          this.IsoCodeList = res.data.data
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        // this.$router.go(0); //刷新页面
      });
    },

    //获取代理链接格式
    getFormatList() {
      this.$request.get('/consum/getFormatList').then((res) => {
        if (res.data.code === 200) {
          this.FormatList = res.data.data;
          // this.IsoCodeList = res.data.data
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },

    //获取子账户
    getSonAccountList() {
      this.$request.get('/ums/Pro/selectSonAccount?id='+ this.uid).then((res) => {
        if (res.data.code === 200) {
          this.sonlist = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },



    //国家变化监听
    changeCode(e){
      this.StateName = "";
      this.AreaList = [];
      this.CityName = "";
      this.CityList = [];
      this.citycode = null;//清空city传值
      this.state = null;//清空state传值
      this.country = e;
      if(this.dyType === "ipidea" || this.dyType === "ipidea2" || this.dyType === "ipidea3"){
        this.getAreaflow();
      }
      if(this.dyType === "ipidea3"){
        this.getAreaflow();
      }
      if(this.dyType === "ipipgo" || this.dyType === "testipipgo"){
        this.getAreaflow();
      }
      if(this.dyType === "zfipweb"){
        this.getAreaflow();
      }
      if(this.dyType === "iproyal"){
        this.getCityflow();
      }
      if(this.dyType === "smart"){
        this.getCityflow();
      }
      this.getProxyList();
    },
    //地区变化监听
    changeState(e){
      this.CityName = "";
      this.CityList = [];
      this.state = e;
      this.citycode = null;//清空city传值
      this.getCityflow();
      this.getProxyList();
    },
    changeCity(e){
      this.citycode = e;
      this.getProxyList();
    },
    //子账户变化监听
    changeSon(e){
      this.sonAccount = e;

      this.getProxyList();
      this.$request.get('/ums/Pro/selectSonAccount?id='+ this.uid).then((res) => {
        if (res.data.code === 200) {
          this.sonlist = res.data.data;
          this.sonlist.forEach((item)=>{
            if(e == item.username){
              this.formData.username = item.username;
              this.formData.host = item.ip;
              this.formData.port = item.port;
              this.formData.password = item.password;
            }
          })
        }
      }).catch((e) => {  console.log(e);})
    },
    //代理格式变化监听
    changeProxy(e){
      this.FormatList.forEach((item)=>{
        if(e == item.dictValue){
          this.formatid = item.dictCode;
        }
      })
      this.getProxyList();
    },
    //时间段轮换
    changeTimes(e){
      if(e == 1){
        this.selectedMode = 1;
      }else if(e == 0){
        this.selectedMode = 0;
      }
      this.getProxyList();
    },
    //代理列表长度变化监听
    changeLength(e){
      this.listnum = e;
      this.getProxyList();
    },
    //代理时间变化监听
    changeTime(e){
      this.life = e;
      this.getProxyList();
    },
    //获取地区
    getAreaflow() {
      this.$request.post('/consum/getStatuList',{datatype:this.dyType,country:this.country}).then((res) => {
        if (res.data.code === 200) {
          this.AreaList = res.data.data;
          console.log(this.AreaList);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },

    //获取城市
    getCityflow() {
      this.$request.post('/consum/getReginlinkList',{datatype:this.dyType,country:this.country,state:this.state}).then((res) => {
        if (res.data.code === 200) {
          this.CityList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },

    //剩余流量，总宽带
    getProxyflow() {
      this.$request.post('/consum/getProxyflow',{packageType:this.value,uid:this.uid}).then((res) => {
        console.log(this.formData);
        if (res.data.code === 200) {
          this.flow = res.data.data.flow;
          this.dyType = res.data.data.datatype;//地区类型
          this.flowoverdue = Number(res.data.data.flow) - Number(res.data.data.flowoverdue);
          this.formData = {...res.data.data}
          //兼容初始化默认选择美国的地区
          this.getAreaflow();
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },

    changeAuthPassword(){
      let changeAccount = this.sonlist.filter((item)=>{
        return item.type == "master"
      })
      console.log('this.sonlist', changeAccount[0]);
      this.$request.post('/ums/updateAuthPassword',{
        nodeId: changeAccount[0].nodeId,
        password:changeAccount[0].password
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.getProxyflow();
          this.getFormatList();
          this.getProxyList();
        }
      })
    },

    //代理列表 consum/getProxyList
    getProxyList() {
      this.$request.post('/consum/getProxyListPro',
        {
          packageType:this.value,
          uid:this.uid,
          city:this.citycode,
          country:this.country,
          formatid:this.formatid,
          life:this.life,
          listnum:this.listnum,
          proxyType:this.proxyType,
          state:this.state,
          uname:this.sonAccount,
          selectedMode:this.selectedMode,

        }
      ).then((res) => {
        if (res.data.code === 200) {
          this.ProxyContant = res.data.data.join('\n')
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },

    //复制
    copy(){
      var clipboard = new Clipboard('#equSN')
      clipboard.on('success', () => {
        this.$message.success('已成功复制到粘贴板')
        //  释放内存
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        // 不支持复制
        this.$message.warning('该浏览器不支持复制')
        // 释放内存
        clipboard.destroy()
      })
    },
    //下载
    downloadTxt() {
      let str = this.ProxyContant;
      let strData = new Blob([str], { type: 'text/plain;charset=utf-8' });
      saveAs(strData, 'proxylink_'+ this.country +'.txt');
    },

  },
  //清空定时器
  beforeDestroy(){
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.noticeTimer) {
      clearInterval(this.noticeTimer);
      this.noticeTimer = null;
    }
  },
};

</script>

<style scoped lang="less">
// 品牌色彩变量定义
@primary-color: #1890ff;
@primary-hover: #40a9ff;
@primary-active: #69c0ff;
@success-color: #52c41a;
@warning-color: #faad14;
@error-color: #f5222d;
@text-primary: #262626;
@text-secondary: #595959;
@text-tertiary: #8c8c8c;
@border-color: #f0f0f0;
@border-hover: #e6f7ff;
@bg-primary: #ffffff;
@bg-secondary: #fafafa;
@bg-gradient: linear-gradient(135deg, @bg-secondary 0%, @bg-primary 100%);
@card-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
@card-shadow-hover: 0 8px 24px rgba(0, 0, 0, 0.12);

.database-container {
  padding: 24px;
  // min-height: 100vh;
  background: #ffffff;
}

/deep/.ant-textarea t-is-readonly {
  margin-top: 50px;
}

@media (max-width: 768px) {
  /deep/.ant-space {
    display: block;
    .ant-space-item {
      margin: 10px 0;
    }
  }
  
  .database-container {
    padding: 12px;
  }
  
  .dashboard-content {
    padding: 16px;
  }
  
  .select-row {
    padding: 16px;
    gap: 16px;
    
    .select-item {
      min-width: 100%;
    }
    
    .select-item-small,
    .select-item-large {
      width: 100%;
    }
  }
  
  .action-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 16px;
    
    .generate-btn,
    .action-btn {
      width: 100%;
      justify-content: center;
    }
  }
  
  .action-buttons {
    display: flex;
    width: 100%;
    gap: 12px;
    
    .action-btn {
      flex: 1;
    }
  }
  
  .content-card {
    :deep(.ant-card-body) {
      padding: 20px;
    }
  }
  
  .flow-card {
    .flow-stats {
      .flow-item {
        .flow-value {
          font-size: 24px;
        }
      }
    }
  }
  
  .proxy-card {
    .proxy-info-item {
      flex-direction: column;
      align-items: stretch;
    }
    
    .proxy-info-label {
      width: 100%;
      border-right: none;
      border-bottom: 1px solid #e8e8e8;
      padding: 12px 20px;
    }
    
    .proxy-info-content {
      padding: 16px 20px;
    }
    
    .proxy-info-tip {
      padding: 0 20px 20px 20px;
    }
  }
  
  .modern-table {
    :deep(.ant-table-thead > tr > th),
    :deep(.ant-table-tbody > tr > td) {
      padding: 12px 8px !important;
      font-size: 13px !important;
    }
    
    :deep(.ant-pagination) {
      margin: 16px 0 0 0 !important;
      text-align: center !important;
      
      .ant-pagination-options {
        display: none;
      }
    }
  }
  
  .card-header {
    margin-bottom: 16px;
    padding-bottom: 16px;
    
    .header-icon {
      font-size: 20px;
      margin-right: 12px;
    }
    
    .header-title {
      font-size: 16px;
    }
  }
}

.announcement-container {
  height: 40px;
  overflow: hidden;
  margin-bottom: 20px;
  background: linear-gradient(90deg, #e6f7ff 0%, #f0faff 100%);
  border: 1px solid #91d5ff;
  border-radius: 8px;
  position: relative;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);

  &::before {
    content: "🔔";
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    z-index: 2;
    color: #1890ff;
  }

  &::after {
    content: "";
    position: absolute;
    left: 42px;
    top: 8px;
    bottom: 8px;
    width: 1px;
    background: linear-gradient(to bottom, transparent, #91d5ff, transparent);
  }
}

.announcement-content {
  padding: 10px 20px 10px 60px;
  box-sizing: border-box;
}

.announcement-item {
  height: 20px;
  line-height: 20px;
  text-align: left;
  font-size: 14px;
  color: #1890ff;
  font-weight: 500;
}



.dashboard-content {
  padding: 24px;
  background: white;
  border-radius: 8px;
}

.content-card {
  border-radius: 16px;
  margin-bottom: 24px;
  box-shadow: @card-shadow;
  transition: all 0.3s ease;
  background: @bg-primary;
  border: 1px solid @border-color;

  &:hover {
    transform: translateY(-2px);
    box-shadow: @card-shadow-hover;
    border-color: @border-hover;
  }

  :deep(.ant-card-body) {
    padding: 28px;
  }
}

/* 流量统计卡片样式 */
.flow-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
  color: white;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><defs><pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse"><path d="M 20 0 L 0 0 0 20" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
    opacity: 0.3;
  }
  
  .flow-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
    
    .flow-icon {
      font-size: 32px;
      margin-right: 16px;
      color: white;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
    
    .flow-title {
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0.5px;
    }
  }
  
  .flow-stats {
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
    
    .flow-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      
      .flow-label {
        font-size: 14px;
        opacity: 0.8;
        font-weight: 500;
      }
      
      .flow-value {
        font-size: 28px;
        font-weight: 700;
        letter-spacing: -0.5px;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      }
    }
  }
  
  :deep(.ant-divider) {
    border-color: rgba(255, 255, 255, 0.2) !important;
    margin: 12px 0 !important;
  }
  
  :deep(.ant-card-body) {
    padding: 32px !important;
  }
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(102, 126, 234, 0.4) !important;
  }
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
  transition: all 0.3s ease;

  .header-icon {
    font-size: 24px;
    color: #1890ff;
    margin-right: 16px;
    transition: all 0.3s ease;
  }

  .header-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.5px;
  }
}

.select-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding: 24px;
  background: linear-gradient(135deg, #fafafa 0%, #ffffff 100%);
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  .select-item {
    flex: 1;
    min-width: 220px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .select-item-small {
    width: 180px;
  }

  .select-item-large {
    flex: 1;
    min-width: 280px;
  }
  
  .config-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .config-label {
    font-size: 14px;
    font-weight: 600;
    color: #595959;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }

  :deep(.ant-select) {
    width: 100%;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    
    .ant-select-selector {
      border-radius: 8px !important;
      height: 40px !important;
      display: flex !important;
      align-items: center !important;
      border: 1px solid #d9d9d9 !important;
      transition: all 0.3s ease !important;
      
      &:hover {
        border-color: #1890ff !important;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15) !important;
      }
      
      &.ant-select-focused {
        border-color: #1890ff !important;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
      }
    }
  }
  
  :deep(.ant-select-selection-placeholder) {
    color: #bfbfbf !important;
    font-size: 14px !important;
  }
}

/* 操作按钮样式 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  padding: 20px;
  background: linear-gradient(135deg, #f0f9ff 0%, #ffffff 100%);
  border-radius: 12px;
  border: 1px solid #e6f7ff;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 16px rgba(24, 144, 255, 0.15);
  }
}

.generate-btn {
  height: 44px;
  font-size: 16px;
  font-weight: 600;
  padding: 0 32px;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%) !important;
  border: none !important;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
    background: linear-gradient(135deg, #40a9ff 0%, #69c0ff 100%) !important;
  }
  
  &:active {
    transform: translateY(0);
  }
}

.action-buttons {
  gap: 12px;
}

.action-btn {
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
  border: 1px solid #d9d9d9;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    border-color: #1890ff;
    color: #1890ff;
  }
}

.copy-btn {
  background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%) !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(82, 196, 26, 0.3);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(82, 196, 26, 0.4);
    background: linear-gradient(135deg, #73d13d 0%, #95de64 100%) !important;
    color: white !important;
  }
}

/* 代理列表文本区域样式 */
.proxy-textarea {
  border-radius: 12px !important;
  border: 2px solid #f0f0f0 !important;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%) !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
  font-size: 14px !important;
  line-height: 1.6 !important;
  
  &:hover {
    border-color: #1890ff !important;
    box-shadow: inset 0 2px 8px rgba(24, 144, 255, 0.1) !important;
  }
  
  &:focus {
    border-color: #1890ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }
  
  :deep(.ant-input) {
    background: transparent !important;
    border: none !important;
    color: #262626 !important;
    padding: 16px !important;
  }
  
  :deep(.ant-input:focus) {
    box-shadow: none !important;
  }
}

/* 现代化表格样式 */
.modern-table {
  border-radius: 12px !important;
  overflow: hidden !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid #f0f0f0 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
    transform: translateY(-2px);
  }
  
  :deep(.ant-table-wrapper) {
    border-radius: 12px !important;
    overflow: hidden !important;
  }
  
  :deep(.ant-table-thead > tr > th) {
    background: linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%) !important;
    border-bottom: 2px solid #e8e8e8 !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    color: #595959 !important;
    padding: 16px 12px !important;
    text-align: left !important;
    letter-spacing: 0.5px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    
    &:hover {
      background: linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%) !important;
      color: @primary-color !important;
    }
  }
  
  :deep(.ant-table-tbody > tr) {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    border-bottom: 1px solid #f5f5f5 !important;
    
    &:hover {
      transform: translateX(4px);
    }
  }
  
  :deep(.ant-table-tbody > tr:hover > td) {
    background: linear-gradient(90deg, #f0f9ff 0%, #ffffff 100%) !important;
    color: @primary-color !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
  
  :deep(.ant-table-tbody > tr > td) {
    padding: 16px 12px !important;
    font-size: 14px !important;
    color: #262626 !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    border-bottom: 1px solid #f5f5f5 !important;
  }
  
  :deep(.ant-table-placeholder) {
    background: white !important;
    padding: 40px 0 !important;
    transition: all 0.3s ease !important;
  }
  
  :deep(.ant-empty-description) {
    color: #8c8c8c !important;
  }
  
  :deep(.ant-pagination) {
    margin: 20px 0 0 0 !important;
    text-align: right !important;
    transition: all 0.3s ease !important;
  }
  
  :deep(.ant-pagination-item) {
    border-radius: 8px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
      border-color: @primary-color !important;
    }
  }
  
  :deep(.ant-pagination-item-active) {
    border-color: @primary-color !important;
    background: @primary-color !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
    
    a {
      color: white !important;
    }
  }
  
  :deep(.ant-pagination-prev:hover .ant-pagination-item-link),
  :deep(.ant-pagination-next:hover .ant-pagination-item-link) {
    border-color: @primary-color !important;
    color: @primary-color !important;
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }
}

/* 平滑过渡动画类 */
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 标签页样式增强 */
:deep(.ant-tabs) {
  transition: all 0.3s ease !important;
}

:deep(.ant-tabs-tab) {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 8px 8px 0 0 !important;
  padding: 12px 24px !important;
  margin: 0 4px !important;
  
  &:hover {
    color: @primary-color !important;
    background: rgba(24, 144, 255, 0.05) !important;
  }
}

:deep(.ant-tabs-tab-active) {
  color: @primary-color !important;
  font-weight: 600 !important;
  
  .ant-tabs-tab-btn {
    color: @primary-color !important;
  }
}

:deep(.ant-tabs-ink-bar) {
  background: @primary-color !important;
  height: 3px !important;
  border-radius: 3px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

:deep(.ant-tabs-content-animated) {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* 公告栏样式 */
.announcement-content {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 按钮微交互增强 */
:deep(.ant-btn) {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:active {
    transform: scale(0.96) !important;
  }
}

/* 选择器微交互增强 */
:deep(.ant-select-dropdown) {
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid #f0f0f0 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

:deep(.ant-select-item-option) {
  transition: all 0.2s ease !important;
  border-radius: 6px !important;
  
  &:hover {
    background: rgba(24, 144, 255, 0.08) !important;
    transform: translateX(4px);
  }
  
  &.ant-select-item-option-selected {
    background: rgba(24, 144, 255, 0.12) !important;
    font-weight: 500 !important;
    
    &:after {
      right: 12px !important;
    }
  }
}

.proxy-card {
  .proxy-info-container {
    margin-bottom: 24px;
    border: 1px solid #e8e8e8;
    border-radius: 16px;
    overflow: hidden;
    transition: all 0.3s ease;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    padding: 0;
    
    &:hover {
      border-color: #1890ff;
      box-shadow: 0 4px 16px rgba(24, 144, 255, 0.15);
    }
  }
  
  .proxy-info-group {
    border-bottom: 1px solid #f5f5f5;
    transition: all 0.3s ease;
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background: linear-gradient(90deg, #f0f9ff 0%, #ffffff 100%);
    }
  }
  
  .proxy-info-item {
    display: flex;
    align-items: center;
    width: 100%;
  }
  
  .proxy-info-label {
    width: 130px;
    padding: 20px;
    background: linear-gradient(90deg, #fafafa 0%, #f5f5f5 100%);
    font-weight: 600;
    font-size: 14px;
    color: #595959;
    border-right: 1px solid #e8e8e8;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    transition: all 0.3s ease;
    margin: 0;
    
    .proxy-info-group:hover & {
      background: linear-gradient(90deg, #e6f7ff 0%, #f0f9ff 100%);
      color: #1890ff;
      border-right-color: #91d5ff;
    }
  }
  
  .proxy-info-content {
    flex: 1;
    padding: 20px;
    font-size: 14px;
    color: #262626;
    font-weight: 500;
    background: white;
    transition: all 0.3s ease;
    margin: 0;
    display: flex;
    align-items: center;
    
    > div {
      display: flex;
      align-items: center;
      width: 100%;
    }
    
    span {
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      color: #1890ff;
      font-weight: 600;
      flex: 1;
    }
    
    .anticon-copy {
      color: #8c8c8c;
      font-size: 16px;
      transition: all 0.3s ease;
      margin-left: 12px;
      flex-shrink: 0;
      
      &:hover {
        color: #1890ff;
        transform: scale(1.1);
      }
    }
    
    .ant-btn {
      margin-left: 12px;
      flex-shrink: 0;
    }
  }
  
  .proxy-info-tip {
    // padding: 0 20px 20px 130px; /* 130px (label width) + 20px (label padding) */
    margin: 12px;
    
    :deep(.ant-alert) {
      // border-radius: 12px;
      // margin: 8px 0 0 0;
      border: 1px solid #e8f4ff;
      background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
      box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
      transition: all 0.3s ease;
      padding: 12px 16px;
      width: 100%;
      box-sizing: border-box;
      
      .ant-alert-message {
        font-size: 13px;
        color: #1890ff;
        font-weight: 500;
        line-height: 1.4;
        text-align: left;
        width: 100%;
        padding-left: 0;
      }
    }
  }
  
  :deep(.ant-btn-primary) {
    height: 32px;
    font-size: 12px;
    font-weight: 500;
    padding: 0 16px;
    background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
    border: none;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(24, 144, 255, 0.3);
    transition: all 0.3s ease;
    flex-shrink: 0;
    
    &:hover {
      background: linear-gradient(135deg, #40a9ff 0%, #69c0ff 100%);
      box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
      transform: translateY(-1px);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
}

.flow-card {
  border-radius: 16px;
  margin-bottom: 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.5);
  }

  :deep(.ant-card-body) {
    padding: 28px;
  }

  .flow-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    .flow-icon {
      font-size: 28px;
      color: white;
      margin-right: 16px;
      filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2));
    }

    .flow-title {
      font-size: 18px;
      font-weight: 600;
      color: white;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    }
  }

  .flow-stats {
    .flow-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      .flow-label {
        color: rgba(255, 255, 255, 0.9);
        font-size: 14px;
        font-weight: 500;
      }
      
      span:last-child {
        font-size: 20px;
        letter-spacing: 0.5px;
        text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      }
    }

    :deep(.ant-divider) {
      margin: 16px 0;
      border-color: rgba(255, 255, 255, 0.2);
    }
  }

  :deep(.ant-progress) {
    margin-top: 24px;
    
    .ant-progress-outer {
      margin: 0;
    }
    
    .ant-progress-bg {
      border-radius: 10px;
      transition: width 1s ease-in-out;
    }
    
    .ant-progress-inner {
      background-color: rgba(255, 255, 255, 0.2);
      border-radius: 10px;
    }
  }
}

.config-item {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .config-label {
    font-size: 13px;
    color: #666;
    font-weight: 500;
  }
}

.proxy-result-card {
  .action-bar {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
    align-items: center;
  }

  .proxy-textarea {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 13px;
    background: #fafafa;
    border-radius: 12px;
    resize: none;
    border: 1px solid #e8e8e8;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: #1890ff;
      box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
    }
    
    :deep(.ant-input) {
      background: #fafafa;
      border: none;
      padding: 16px;
      color: #333;
      font-weight: 500;
    }
  }
  
  :deep(.ant-btn-primary) {
    height: 44px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
    padding: 0 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
      background: linear-gradient(135deg, #5a6fd8 0%, #6a408f 100%);
    }
  }
  
  :deep(.ant-btn) {
    height: 44px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    padding: 0 20px;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }
}

.custom-tabs {
  :deep(.ant-tabs-nav) {
    margin-bottom: 24px;
    padding: 0 16px;
    
    &::before {
      border-bottom: 1px solid #f0f0f0;
    }
  }

  :deep(.ant-tabs-tab) {
    padding: 12px 24px;
    border-radius: 8px 8px 0 0;
    transition: all 0.3s ease;
    margin-right: 8px;

    &:hover {
      background: rgba(24, 144, 255, 0.1);
    }

    &.ant-tabs-tab-active {
      background: white;
      border: 1px solid #f0f0f0;
      border-bottom-color: white;
      position: relative;
      z-index: 1;

      .ant-tabs-tab-btn {
        color: #1890ff;
        font-weight: 500;
      }
    }
  }

  :deep(.ant-tabs-content) {
    background: white;
    border: 1px solid #f0f0f0;
    border-top: none;
    border-radius: 0 8px 8px 8px;
    padding: 0;
  }

  :deep(.ant-tabs-tabpane) {
    padding: 0;
  }

  :deep(.ant-tabs-ink-bar) {
    display: none;
  }
}

.custom-table {
  :deep(.ant-table-thead > tr > th) {
    background: #fafafa;
    font-weight: 600;
    border-bottom: 2px solid #f0f0f0;
  }

  :deep(.ant-table-tbody > tr:hover > td) {
    background: #e6f7ff;
  }

  :deep(.ant-table-row) {
    transition: all 0.3s ease;
  }
}

@media (max-width: 768px) {
  .database-container {
    padding: 8px 0;
  }

  .content-card {
    :deep(.ant-card-body) {
      padding: 12px;
    }
  }

  .custom-tabs /deep/ .ant-tabs-nav-container {
    padding: 0;
  }

  .custom-tabs /deep/ .ant-tabs-nav-wrap {
    margin: 0;
  }

  .custom-tabs /deep/ .ant-tabs-nav {
    width: 100%;
    padding: 0;
  }

  .custom-tabs /deep/ .ant-tabs-nav > div {
    display: flex;
    width: 100%;
  }

  .custom-tabs /deep/ .ant-tabs-tab {
    flex: 1 1 0;
    min-width: 0;
    margin: 0 !important;
    padding: 12px 6px !important;
    text-align: center;
    white-space: normal;
  }

  .custom-tabs /deep/ .ant-tabs-tab-arrow-show {
    display: none;
  }

  .select-row {
    flex-direction: column;

    .select-item,
    .select-item-small,
    .select-item-large {
      width: 100%;
    }
  }

  .config-item {
    width: 100%;
  }
}

/* 紧凑样式 */
.compact-card {
  :deep(.ant-card-body) {
    padding: 20px !important;
  }
}

.compact-header {
  margin-bottom: 16px !important;
  padding-bottom: 16px !important;
}

.compact-header .flow-title,
.compact-header .header-title {
  font-size: 16px !important;
}

.compact-header .flow-icon {
  font-size: 24px !important;
}

.compact-stats {
  .flow-item {
    margin-bottom: 12px !important;
  }
  
  :deep(.ant-divider) {
    margin: 8px 0 !important;
  }
}

.compact-stats .flow-label {
  font-size: 13px !important;
}

.compact-stats span:last-child {
  font-size: 18px !important;
}

.compact-proxy {
  .proxy-info-label {
    padding: 16px !important;
    font-size: 13px !important;
  }
  
  .proxy-info-content {
    padding: 16px !important;
    font-size: 13px !important;
  }
  
  .proxy-info-tip {
    // padding: 0 16px 16px 130px !important;
  }
}

.compact-tip {
  :deep(.ant-alert) {
    // margin: 4px 0 0 0 !important;
    padding: 8px 12px !important;
  }
  
  :deep(.ant-alert-message) {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }
}

/* 突出右侧代理生成卡片 */
.highlight-card {
  box-shadow: 0 8px 28px rgba(102, 126, 234, 0.3) !important;
  transform: translateY(0);
  
  &:hover {
    box-shadow: 0 12px 40px rgba(102, 126, 234, 0.4) !important;
    transform: translateY(-4px);
  }
  
  .card-header {
    border-bottom-color: #e6f7ff;
    
    .header-icon {
      color: #667eea;
      font-size: 26px;
    }
    
    .header-title {
      color: #667eea;
      font-size: 20px;
      font-weight: 700;
    }
  }
}
</style>
